import React from 'react'
import Button from '@material-ui/core/Button'
import { makeStyles, Theme } from '@material-ui/core/styles'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import Box from '@material-ui/core/Box'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../../messages'
import { fastDuplexOligosRoute, useRouter } from '@src/routes'
import { biTubeConfigContext } from '../../BiTube'
import { ActiveLinkType, BiTubeProduct, BitubeProperties } from '../../enum'

const useStyles = makeStyles((theme: Theme) => ({
  box: {
    borderStyle: 'dashed',
    borderColor: theme.palette.grey[900],
    borderWidth: 1,
  },
  button: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.primary.main,
    margin: theme.spacing(6),
  },
  icon: {
    color: theme.palette.primary.main,
  },
}))

const AddOligo = (props) => {
  const classes = useStyles()
  const { bitubeState, biTubeDispatch } = React.useContext(biTubeConfigContext)
  const { oligoCount, sessionData } = bitubeState
  const { productType, updateError, errorMessage } = props
  const router = useRouter()
  const sequencePath = `${fastDuplexOligosRoute.index()}?product=${productType}&activeLink=${
    ActiveLinkType.SequenceEntry
  }`
  const intl = useIntl()
  const maxItems = BitubeProperties.MaximumOligosAllowed
  const addProductFromConfirm = () => {
    if (errorMessage !== undefined && errorMessage !== '') {
      updateError(errorMessage)
    } else {
      if (sessionData.length < BitubeProperties.MaximumOligosAllowed) {
        biTubeDispatch({ type: 'IS_COMING_FROM_CONFIGM_PAGE', data: true })
        router.push(sequencePath)
        biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
        biTubeDispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: true })
        biTubeDispatch({ type: 'ADD_NEW_OLIGO', data: oligoCount + 1 })
        biTubeDispatch({
          type: 'ADD_NEW_DUPLEX',
          data: true,
        })
      } else {
        updateError(
          intl.formatMessage(messages.CONF_MAX_ITEMS_ALLOWED, { maxItems })
        )
      }
    }
    window.scrollTo(0, 0)
  }
  return (
    <Box
      mb={4}
      display="flex"
      justifyContent="center"
      borderRadius="borderRadius"
      className={classes.box}
    >
      <Button
        onClick={addProductFromConfirm}
        size="medium"
        className={classes.button}
        startIcon={<AddCircleIcon fontSize="small" className={classes.icon} />}
      >
        {productType === BiTubeProduct.LightCycler ? (
          <FormattedMessage {...messages.CONF_ADD_OLIGO_SIDE_BAR} />
        ) : (
          <FormattedMessage {...messages.CONF_ADD_DUPLEX_SIDE_BAR} />
        )}
      </Button>
    </Box>
  )
}
export default AddOligo
